<template>
  <Content>
    <Anchor class="video-links-anchor" :offset-top="110" :bounds="40" :show-ink="true">
      <AnchorLink :title="$t('manage.videos.introduction')" href="#0" />
      <AnchorLink title="Logic and Concepts" href="#1" />
      <AnchorLink title="Letter Sounds" href="#2" />
      <AnchorLink title="Listening to Stories" href="#3" />
      <AnchorLink title="Letter Shapes" href="#4" />
      <AnchorLink title="Writing" href="#5" />
      <AnchorLink title="Blending" href="#6" />
      <AnchorLink title="Words" href="#7" />
      <AnchorLink title="Sentences and Reading Comprehension" href="#8" />
      <AnchorLink title="Reading Stories" href="#9" />
      <AnchorLink title="How to use the App Book" href="#10" />
    </Anchor>
    <!-- TRANSCODE COMMAND: for i in *.mp4; do ffmpeg -i "$i" -vf scale=-1:720 -c:v libx264 -crf 35 -preset fast -c:a copy "${i%.*}-small.mp4"; done -->
    <Card>
      <template slot="title">{{$t('manage.videos.stations')}}</template>
      <ol style="padding: 25px; padding-top: 5px;">
        <li><a href="#0">{{$t('manage.videos.introduction')}}</a> (7:21)</li>
        <li><a href="#1">Logic and Concepts</a> (4:30)</li>
        <li><a href="#2">Letter Sounds</a> (5:33)</li>
        <li><a href="#3">Listening to Stories</a> (4:25)</li>
        <li><a href="#4">Letter Shapes</a> (5:16)</li>
        <li><a href="#5">Writing</a> (4:46)</li>
        <li><a href="#6">Blending</a> (3:26)</li>
        <li><a href="#7">Words</a> (4:44)</li>
        <li><a href="#8">Sentences and Reading Comprehension</a> (3:20)</li>
        <li><a href="#9">Reading Stories</a> (2:58)</li>
        <li><a href="#10">How to use the App Book</a> (3:20)</li>
        <li><a href="#11">How to facilitate</a> (9:02)</li>
      </ol>
    </Card>
    <Card class="video-card" id="0">
      <!-- <template slot="title">&nbsp;</template> -->
      <youtube video-id="_xJCVpObAgU" @ready="videoReady"></youtube>
      <div class="title">{{$t('manage.videos.introduction')}}</div>
      <a class="btn1" :href="`${publicPath}files/learning-lab-presentation.mp4`" download="learning-lab-presentation.mp4">
        <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (500 MB)</Button>
      </a>
      <a class="btn2" :href="`${publicPath}files/learning-lab-presentation-small.mp4`" download="learning-lab-presentation-small.mp4">
        <Button icon="ios-download-outline" class="btn-dark" type="default">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (29 MB)</Button>
      </a>
      <ElementLoader :show="videoLoading" />
    </Card>

      <Card name="1" class="light-blue video-card" id="1">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="pCYiGSI7A6s"></youtube>
        <div class="title">Light Blue Station - Logic and Concepts</div>
        <a class="btn1" :href="`${publicPath}files/station-0-logic.mp4`" download="station-0-logic.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (100 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-0-logic-small.mp4`" download="station-0-logic-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (14 MB)</Button>
        </a>
      </Card>
      <Card name="2" class="blue video-card" id="2">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="p_f1DejW3CU"></youtube>
        <div class="title">Blue Station - Letter Sounds</div>
        <a class="btn1" :href="`${publicPath}files/station-1-letter-sounds.mp4`" download="station-1-letter-sounds.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (124 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-1-letter-sounds-small.mp4`" download="station-1-letter-sounds-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (18 MB)</Button>
        </a>
      </Card>
      <Card name="3" class="green video-card" id="3">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="ugbKvncbF78"></youtube>
        <div class="title">Green Station - Listening to Stories</div>
        <a class="btn1" :href="`${publicPath}files/station-2-listening-to-stories.mp4`" download="station-2-listening-to-stories.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (95 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-2-listening-to-stories-small.mp4`" download="station-2-listening-to-stories-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (14 MB)</Button>
        </a>
      </Card>
      <Card name="4" class="yellow video-card" id="4">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="kjJbjGH1WIQ"></youtube>
        <div class="title">Yellow Station - Letter Shapes</div>
        <a class="btn1" :href="`${publicPath}files/station-3-letter-shapes.mp4`" download="station-3-letter-shapes.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (114 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-3-letter-shapes-small.mp4`" download="station-3-letter-shapes-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (18 MB)</Button>
        </a>
      </Card>
      <Card name="5" class="orange video-card" id="5">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="Pq_nn3QHPSk"></youtube>
        <div class="title">Orange Station - Writing</div>
        <a class="btn1" :href="`${publicPath}files/station-4-writing.mp4`" download="station-4-writing.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (327 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-4-writing-small.mp4`" download="station-4-writing-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (20 MB)</Button>
        </a>
      </Card>
      <Card name="6" class="red video-card" id="6">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="_ZLDgTNaMOE"></youtube>
        <div class="title">Red Station - Blending</div>
        <a class="btn1" :href="`${publicPath}files/station-5-blending.mp4`" download="station-5-blending.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (76 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-5-blending-small.mp4`" download="station-5-blending-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (14 MB)</Button>
        </a>
      </Card>
      <Card name="7" class="pink video-card" id="7">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="p4Y5jn7V4Bo"></youtube>
        <div class="title">Pink Station - Words</div>
        <a class="btn1" :href="`${publicPath}files/station-6-words.mp4`" download="station-6-words.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (126 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-6-words-small.mp4`" download="station-6-words-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (15 MB)</Button>
        </a>
      </Card>
      <Card name="8" class="purple video-card" id="8">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="pgIkGM-GlLk"></youtube>
        <div class="title">Purple Station - Sentences and Reading Comprehension</div>
        <a class="btn1" :href="`${publicPath}files/station-7-purple.mp4`" download="station-7-purple.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (72 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-7-purple-small.mp4`" download="station-7-purple-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (11 MB)</Button>
        </a>
      </Card>
      <Card name="9" class="dark-blue video-card" id="9">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="ReuzTLNtsOg"></youtube>
        <div class="title">Dark Blue Station - Reading Stories</div>
        <a class="btn1" :href="`${publicPath}files/station-8-reading-stories.mp4`" download="station-8-reading-stories.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (63 MB)</Button>
        </a>
        <a class="btn2" :href="`${publicPath}files/station-8-reading-stories-small.mp4`" download="station-8-reading-stories-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (9.8 MB)</Button>
        </a>
      </Card>

      <Card name="10" class="video-card" id="10">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="SH-tMZSE3yM"></youtube>
        <div class="title">How to use the App Book</div>
        <a class="btn1" :href="`${publicPath}files/App book & task book FEEDBACK.mp4`" download="App book & task book FEEDBACK.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (74 MB)</Button>
        </a>
        <!-- <a class="btn2" :href="`${publicPath}files/station-8-reading-stories-small.mp4`" download="station-8-reading-stories-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (9.8 MB)</Button>
        </a> -->
      </Card>

      <Card name="11" class="video-card" id="11">
        <!-- <template slot="title">&nbsp;</template> -->
        <youtube video-id="a8fi8PfCVUg"></youtube>
        <div class="title">How to facilitate</div>
        <a class="btn1" :href="`${publicPath}files/Facilitating FEEDBACK 210219.mp4`" download="Facilitating FEEDBACK 210219.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.hires')}} (198 MB)</Button>
        </a>
        <!-- <a class="btn2" :href="`${publicPath}files/station-8-reading-stories-small.mp4`" download="station-8-reading-stories-small.mp4">
          <Button icon="ios-download-outline" class="btn-dark" type="primary">{{$t('manage.videos.download')}} {{$t('manage.videos.lowres')}} (9.8 MB)</Button>
        </a> -->
      </Card>
  </Content>
</template>

<script>
import ElementLoader from '../../components/ElementLoader.vue';

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      videoLoading: true
    }
  },
  methods: {
    videoReady() {
      this.videoLoading = false;
    }
  },
  components: {
    ElementLoader
  }
}
</script>

<style scoped lang="scss">
.main-content {
  text-align: center;

  .ivu-card {
    margin: 40px auto;
    font-size: 16px !important;

    .btn2 {
      @include respond-to(large) {
        margin-left: 15px;
      }
      @include respond-to(tablet) {
        button { margin-top: 10px; }
      }
      @include respond-to(phone) {
        button { margin-top: 10px; }
      }
    }
  }

  ul {
    list-style: none;

    li {
      line-height: 24px !important;
    }
  }
}
</style>

<style lang="scss">
.main-content {
  .video-card {
    margin: 40px auto;
    text-align: center;

    .ivu-card-body div.title {
      margin: 15px auto;
      font-size: 1.2em;

      @include respond-to(tablet) {
        font-size: 1em;
      }
      @include respond-to(phone) {
        font-size: 0.9em;
      }
    }

    iframe {
      max-width: 100%;
    }

    &.light-blue .ivu-card-head {
      background-color: rgb(203,228,243);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: #140d00;
      }
    }
    &.blue .ivu-card-head {
      background-color: rgb(122,207,226);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: #140d00;
      }
    }
    &.green .ivu-card-head {
      background-color: rgb(118,240,24);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: #140d00;
      }
    }
    &.yellow .ivu-card-head {
      background-color: rgb(249,242,146);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: #140d00;
      }
    }
    &.orange .ivu-card-head {
      background-color: rgb(241,198,129);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: #140d00;
      }
    }
    &.red .ivu-card-head {
      background-color: rgb(237,71,69);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: white;
      }
    }
    &.pink .ivu-card-head {
      background-color: rgb(232,85,188);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: white;
      }
    }
    &.purple .ivu-card-head {
      background-color: rgb(143,77,232);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: white;
      }
    }
    &.dark-blue .ivu-card-head {
      background-color: rgb(40,52,131);

      .ivu-collapse-header span,
      .ivu-collapse-header i {
        color: white;
      }
    }

  }

  .video-links-anchor {
    width: 250px;
    position: fixed;
    top: 110px !important;
    right: 50px !important;
    left: auto !important;

    @include respond-to(phone) {
      display: none;
    }
    @include respond-to(tablet) {
      display: none;
    }

    .ivu-affix {
      position: fixed;
      top: 110px !important;
      right: 50px !important;
      left: auto !important;
      width: auto !important;
    }
  }

  .btn-dark {
    background: #5a5a5a;
    color: white;
    border-color: #5a5a5a;

    &:hover {
      background: lighten(#5a5a5a, 15%);
      color: white;
      border-color: #5a5a5a;
    }
  }
}
</style>